export enum ZoneMeta {
  MODEL = "zone",
  PK = "id",
}
